import React from 'react';
import { LinkModel } from '../../Types/LinkModel';
import clsx from 'clsx';

export interface BannerItemProps {
  imageUrl: string;
  linkText?: string;
  actionText?: string;
  overlay: boolean;
  link?: LinkModel;
  bodyText?: string;
  lazyLoadImage?: boolean;
  className?: string;
  systemId: string;
}

const BannerBlockItem = ({
  imageUrl,
  linkText,
  actionText,
  overlay,
  link,
  bodyText,
  lazyLoadImage = false,
  className,
}: BannerItemProps) => {
  const hasLinkButton = link && actionText;

  const DivOrAnchor = ({ children, ...rest }) =>
    hasLinkButton && link?.href ? (
      <a {...rest}>{children}</a>
    ) : (
      <div {...rest}>{children}</div>
    );

  return (
    <DivOrAnchor
      className={clsx(
        className,
        'text-white',
        'overflow-hidden',
        'transition',
        'duration-300',
        'text-center',
        'grid'
      )}
      href={link?.href}
    >
      <img
        className={clsx(
          'banner-item-image',
          'col-start-1',
          'row-start-1',
          'w-full',
          'aspect-video',
          'object-cover',
          'xl:aspect-[21/9]'
        )}
        src={imageUrl}
        loading={lazyLoadImage ? 'lazy' : undefined}
      />
      <div
        className={clsx(
          'w-full',
          'h-full',
          'col-start-1',
          'row-start-1',
          'z-10',
          'flex',
          'items-center',
          'justify-center',
          'flex-col',
          'max-w-[600px]',
          'mx-auto',
          'px-4',
          'py-0',
          'box-border',
          'lg:px-6'
        )}
      >
        <h4 className="mb-2">{linkText}</h4>
        {bodyText && <p className="mb-4">{bodyText}</p>}
        {hasLinkButton && (
          <a href={link.href} className="self-center">
            <button className="btn btn--primary btn--large">
              {actionText}
            </button>
          </a>
        )}
      </div>
      {overlay && (
        <div
          className={clsx(
            'col-start-1',
            'row-start-1',
            'w-full',
            'h-full',
            'z-0',
            'bg-[rgba(0,0,0,0.551)]',
            'pointer-events-none',
            'aspect-video',
            'xl:aspect-[21/9]'
          )}
        ></div>
      )}
    </DivOrAnchor>
  );
};

export default BannerBlockItem;
